import { KeyboardContext } from './types';

/** @description get keyboard context based on active element */
export function getCurrentKeyboardContext(): KeyboardContext {
  const el = document.activeElement;
  if (!(el instanceof HTMLElement)) return 'canvas';

  if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') {
    return 'propertyPanel';
  }

  if (el.isContentEditable) return 'propertyPanel';

  return 'canvas';
}
